import { Component } from 'react'
import Profile from './Profile'
import Intelligence from './Intelligence'
import AreaOfOperations from './AreaOfOperations'
import Contact from './Contact'
import AboutUs from './AboutUs'
import IndustryServed from './IndustryServed'
import KeyFocusArea from './KeyFocusArea'
import Customers from './Customers'
import ManPower from './ManPower'
import Warehousing from './Warehousing'
import ValueAddedServices from './ValueAddedServices'
import AcceptableTerms from './AcceptableTerms'
import TruckAssetsDetails from './TruckAssestsDetails'
import BankDetails from './BankDetails'
import GSTDetails from './GSTDetails'
import Other from './Other'
import ShipmentMethod from './ShipmentMethod'
import Loader from '../../Loader'
import { encryptor } from '../../../Constants' // , Activity, ActivityString, currentRequestTimeStamp
import './style.css'
import Unauthorized from '../../Unauthorized'
import { connect } from 'react-redux'
import { fetchData } from './redux/actions'
import AdditionalDetails from './AdditionalDetails/AdditionalDetails'
import Licenses from './LicensesAndCertifications/Licenses'
import TmsExperience from './TMSExperience/TMS'
// import html2pdf from 'html2pdf.js';
// import html2canvas from 'html2canvas'
// import ContactV from './Contact copy/ContactV'
import AssetDetailsExport from './AssetDetailsForExport/AssetDetailsExport'
import { UserApiContext } from '../../UserDetailsContext/UserDetailsContext'
import NewMapTransporterProfile from './Map/NewMap'

// let transporter_data
let transporter_id = ''
class TransporterDetailsBody extends Component {

  constructor(props) {
    super(props)
    this.state = {
      transporter_id: props.transporter_id,
      transporter_data: '',
      profile_data:'',
      map_data: '',
      branch_data: '',
      network_data: '',
      status: '',
      loader: false,
      errorMessage: '',
      branchLoader:false,
      networkLoader: false,
      profileLoader: false,
      leftdetailsloader:false,
      intelligenceloader:false,
      remainingloader: false,
      left_details:'',
      intelligence_data: '',
      remaining_data:'',
      nextupdate: true,
      profile_view_allowed: 'no',
      profile_view_count: 0
    }
    this.handlefetchdata = this.handlefetchdata.bind(this)
    // this.downloadPDF = this.downloadPDF.bind(this);
  }

  handlefetchdata(transporter_id) {
    this.props.fetchData(transporter_id)

  }
  componentWillUnmount() {
    this.setState({transporter_data:''})
  }
  
  componentWillMount() {
    if(this.props.property.props.from !== 'modal'){
      transporter_id = encryptor(this.props.property.props.match.params.name, false);
      if(transporter_id !== undefined && transporter_id !== null && transporter_id !== ''){
        this.handlefetchdata(transporter_id)
      }
    }
    if(this.props && this.props.property && this.props.property.props && this.props.property.props.transporter_id){
      this.handlefetchdata(this.props.property.props.transporter_id)
    }

  }

  // this is to fetch transporter data when the transporter_id changes
  componentDidUpdate(prevProps) {
    const prevId = prevProps.transporter_id || prevProps.property?.props?.transporter_id;
    const currentId = this.props.transporter_id || this.props.property?.props?.transporter_id;

    if (prevId !== currentId) {
      const transporter_id = this.props.property?.props?.from !== 'modal'
        ? encryptor(this.props.property?.props?.match?.params?.name, false)
        : this.props.property?.props?.transporter_id;

      if (transporter_id) {
        this.handlefetchdata(transporter_id);
      }
    }
  }

  componentDidMount() {
    setTimeout(() => {
      }, 500);
  }

  // getData = () => {
  //   transporter_id = encryptor(this.props.match.params.name, false);
  //   if(transporter_id !== undefined && transporter_id !== null && transporter_id !== ''){
  //     this.setState({ networkLoader: true }, () => {
  //       axios.get(`${Urls.Transporters.Get1}?transporter_id=${transporter_id}&projection=transporter_network`)
  //         .then(res => {
  //           // console.log(res.data)

  //           if (res.data.error || res.data.status === false) {
  //             this.setState({
  //               status: false,
  //               errorMessage: res.data.error
  //             })
  //           }
  //           sessionStorage.setItem('client_transporter_code', res.data.profile_code)
  //           this.setState(
  //             {
  //               network_data:res.data,
  //               // transporter_data: res.data,
  //               networkLoader: false

  //             }, () => {  }
  //           )
  //         })
  //         .catch(err => {
  //           console.log(err);
  //           this.setState({ networkLoader: false })
  //         })
  //     })
  //   }
  // }


  // this is removed
  // downloadPDF() {
  //   const input = document.getElementById('export');
  
  //   document.getElementById("mapComponent").style.display = "none"
  //   document.getElementById("exportAssetDetails").style.display = "block"
  //   document.getElementById("exportBranchList").style.display = "block"
  //   document.getElementById("AssetCard").style.display = "none"
  //   document.getElementById("export-btn").style.display = "none"
  //   document.getElementById("contact").style.display = "none"
  //   document.getElementById("exportContact").style.display = "block"
  
  //   var ExportHeight = input.scrollHeight
  
  //   // Use html2canvas to capture the map as an image
  //   html2canvas(input).then((canvas) => {
  //     html2pdf(input, {
  //       margin: 10,
  //       filename: `${this.props.transporter_data.transporter_name}.pdf`,
  //       image: { type: 'jpeg', quality: 0.98 },
  //       html2canvas: { scale: 2 },
  //       jsPDF: { unit: 'px', format: [ExportHeight, 2000], orientation: 'portrait' },
  //       // pagebreak: { mode: ['avoid-all', 'css', 'legacy'] },
  //     }).then(() => {
  //       // Show the elements after the PDF generation is completed
  //       document.getElementById("mapComponent").style.display = "block"
  //       document.getElementById("exportAssetDetails").style.display = "none"
  //       document.getElementById("AssetCard").style.display = "block"
  //   document.getElementById("exportBranchList").style.display = "none"
  //   document.getElementById("export-btn").style.display = "block"
  //   document.getElementById("contact").style.display = "block"
  //   document.getElementById("exportContact").style.display = "none"

  //     });
  //   });
  // }
  

  testfunc(){
    
  }


  render() {
    return (
      <UserApiContext.Consumer>
        {({userDetails}) => (
          <>
          {this.props.transporter_data.status === false ? (
            <Unauthorized message='You do not have access to this service or you are running out of credits!' />
          ) 
          :
         
          (
              <div id="export" className="body jumbotron align-items-end text-wrap">
                {/* removed becoz package is old */}
                {/* {
                userDetails?.policy?.profile_download?.allowed === "yes" ? (
                  <button id="export-btn" className='btn btn-primary'
                    style={{position: "absolute", top: "30px" ,right: "20px"}}
                    onClick={this.downloadPDF}>
                      Export to PDF
                  </button>
                ) : null} */}
                <div className="row client_body">
                {/* {console.log(this.props.transporter_data)} */}

                  <div className="col-lg-4 col-md-4 left_col">
                    <div className="row">
                      <div className="col-12 profile hovertest">
                        {/* <Profile transporter_data={this.state.transporter_data} /> */}
                        <Profile transporter_data={this.props.transporter_data} />
                      </div>
                      <div className="col-12 aboutUs hovertest">
                        {/* <AboutUs transporter_data={this.state.transporter_data} /> */}
                        <AboutUs transporter_data={this.props.transporter_data} />
                      </div>
                      <div className="col-12 industryServed hovertest">
                        {/* <IndustryServed transporter_data={this.state.transporter_data} /> */}
                        <IndustryServed transporter_data={this.props.transporter_data} />
                      </div>
                      <div className="col-12 keyFocusArea hovertest">
                        {/* <KeyFocusArea transporter_data={this.state.transporter_data} /> */}
                        <KeyFocusArea transporter_data={this.props.transporter_data} />
                      </div>
                      <div className="col-12 acceptableTerms hovertest">
                        {/* <AcceptableTerms transporter_data={this.state.transporter_data} /> */}
                        <AcceptableTerms transporter_data={this.props.transporter_data} />
                      </div>
                      <div className="col-12 bankDetails hovertest">
                        {/* <BankDetails transporter_data={this.state.transporter_data} /> */}
                        <BankDetails transporter_data={this.props.transporter_data} />
                      </div>
                      <div className="col-12 otherBusinessInterest hovertest">
                        {/* <Other transporter_data={this.state.transporter_data} /> */}
                        <Other transporter_data={this.props.transporter_data} />
                      </div>
                        <div className="col-12 otherBusinessInterest hovertest">
                        {/* <Other transporter_data={this.state.transporter_data} /> */}
                        <AdditionalDetails transporter_data={this.props.transporter_data} />
                      </div>
                      
                    </div>
                  </div>

                  <div className="col-lg-8 col-md-8 right_col s-height" >
                    <div className="row">
                      <div className="col-11 intelligence hovertest">
                        {/* <Intelligence intelligencedata={this.state.transporter_data} /> */}
                        <Intelligence intelligencedata={this.props.transporter_data} />
                      </div>
                      <div className="col-3 areaOfOperations hovertest">
                        {/* <AreaOfOperations transporter_data={this.state.transporter_data} /> */}
                        <AreaOfOperations transporter_data={this.props.transporter_data} />
                      </div>
                      <div className="col-11 contactInformation s-height" id="contact">
                        {/* <Contact className="s-width" transporter_data={this.state.transporter_data}/> contact_information */}
                        <Contact className="s-width" transporter_data={this.props.transporter_data}/> {/* contact_information */}
                      </div>
                      {/* commented out since display none */}
                      {/* <div className="col-11 contactInformation s-height" id="exportContact" style={{display: "none"}}>
                        <ContactV className="s-width" transporter_data={this.props.transporter_data}/>
                      </div> */}
                      <div className="col-4 warehouseService hovertest p-3" id="exportBranchList" style={{display: "none"}}>
                        <div>Branch List: {this.props.transporter_data?.branch_count ?? 0}</div>
                        <div>Operating Lanes: {this.props.transporter_data?.network_count ?? 0}</div>
                      </div>
                      <div className="col-11 map s-map" id="mapComponent">
                        <NewMapTransporterProfile map_data={this.props.transporter_data} />

                      </div>
                      <div className="col-11 customers hovertest">
                        {/* <Customers topCompanies={this.state.transporter_data} />  */}
                        <Customers topCompanies={this.props.transporter_data} /> 
                      </div>

                      <div className="col-4 warehouseService hovertest">
                        {/* <Warehousing transporter_data={this.state.transporter_data} />   */}
                        <Warehousing transporter_data={this.props.transporter_data} />  
                      </div>
                      <div className="col-7 gst hovertest">
                        {/* <GSTDetails transporter_data={this.state.transporter_data} />  */}
                        <GSTDetails transporter_data={this.props.transporter_data} /> 
                      </div>

                      <div className="col-11 truckAssetDetails hovertest" id="AssetCard" style={{display: "block"}}>
                        {/* <TruckAssetsDetails truckAssetDetails={this.state.transporter_data} />  */}
                        <TruckAssetsDetails truckAssetDetails={this.props.transporter_data} /> 
                      </div>
                      <div className="col-11 shipmentMethod hovertest" id="exportAssetDetails" style={{ display: "none" }}>
                        {/* <ShipmentMethod methodDetails={this.state.transporter_data} />  */}
                        <AssetDetailsExport transporter_data={this.props.transporter_data} /> 
                      </div>
                      <div className="col-6 shipmentMethod hovertest">
                        {/* <ShipmentMethod methodDetails={this.state.transporter_data} />  */}
                        <Licenses transporter_data={this.props.transporter_data} /> 
                      </div>
                      <div className="col-5 otherBusinessInterest hovertest" style={{padding: '1%'}}>
                        <TmsExperience transporter_data={this.props.transporter_data} /> 
                      </div>
                      <div className="col-8 valueAddedService hovertest">
                        {/* <ValueAddedServices transporter_data={this.state.transporter_data} />  */}
                        <ValueAddedServices transporter_data={this.props.transporter_data} /> 
                      </div>
                      <div className="col-3 manPower hovertest" >
                        {/* <ManPower transporter_data={this.state.transporter_data} />  */}
                        <ManPower transporter_data={this.props.transporter_data} /> 
                      </div>
                      <div className="col-11 shipmentMethod hovertest">
                        {/* <ShipmentMethod methodDetails={this.state.transporter_data} />  */}
                        <ShipmentMethod methodDetails={this.props.transporter_data} /> 
                      </div>
                      
                    </div>
                  </div>


                </div>

                <Loader
                  show={this.props.fetchDataReducer.loading} 
                  message={'Loading Transporter Details'} 
                  overlayStyles={{
                    backgroundColor: "rgba(255, 255, 255, 1)",
                    opacity: "1",
                    backdropFilter: "blur(250px)",
                  }}
                />
              </div>
            )
            }
      </>
        )}
    </UserApiContext.Consumer>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    ...state,
    transporter_data: state.fetchDataReducer.transporter_data,
    err: state.fetchDataReducer.err
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchData: (transporter_id) => {
      // console.log(transporter_id)
      dispatch(fetchData(transporter_id))
    }
  }
}



export default connect(mapStateToProps, mapDispatchToProps)(TransporterDetailsBody)